import { useEffect, useMemo, useState } from 'react'
import useCampaign from '@pig-casino/hooks/useCampaign'
import usePromotions from '@pig-casino/hooks/usePromotions'
import orderBy from 'lodash/orderBy'
import { useMediaQuery, Image } from '@pig-frontend/uikit'
import { IPromotionsItem } from '@pig-casino/types/Promotions.type'
import { Section } from '@pig-frontend/uikit'
import { promotionImageAssetUrl } from '@pig-casino/utils/promotion-image-url'
import { useRouter } from 'next/router'
import { pageLinkCommon } from '@pig-common/constants/page-name'
import { RightOutlined } from '@ant-design/icons'
import { promotionHeaderImage } from '@pig-casino/constants/images'
import { campaignApi, promotionsApi } from '@pig-casino/api'
import {
  withMiddleware,
  revalidate,
} from '@pig-casino/middlewares/get-serverside-props'
import Head from 'next/head'
import { useQueryClient } from '@tanstack/react-query'
import styles from './index.module.scss'
import Link from 'next/link'
import { PIGSPIN_URL } from '@pig-casino/constants/env'
import { ICampaignsResultData } from '@pig-casino/types/Campaign.type'

export default function Promotions() {
  const router = useRouter()
  const queryClient = useQueryClient()
  const isMD = useMediaQuery('md')
  const [errorImage, setErrorImage] = useState([])
  const { data: campaigns = [] } = useCampaign({
    params: { productType: 'PIG_BET' },
  })
  const { data: promotions = [] } = usePromotions({
    params: { productType: 'PIG_BET' },
  })
  const allPromotions = useMemo(() => {
    if (Array.isArray(promotions) && Array.isArray(campaigns)) {
      return orderBy(
        [...promotions, ...campaigns],
        'order',
      ) as (IPromotionsItem & ICampaignsResultData)[]
    } else {
      return []
    }
  }, [promotions, campaigns])

  const handleClick = (isCampaign, code) => {
    if (isCampaign) {
      router.push(`${pageLinkCommon.campaigns}/${code}`)
    } else {
      router.push(`${pageLinkCommon.promotions}/${code}`)
    }
  }

  useEffect(() => {
    return () => {
      queryClient.cancelQueries({ queryKey: [campaignApi.key.list] })
      queryClient.cancelQueries({ queryKey: [promotionsApi.key.list] })
    }
  }, [])

  return (
    <>
      <Head>
        <title>
          เว็บพนันออนไลน์ที่ดีที่สุด โปรโมชั่นแจกเครดิตฟรี สมาชิกใหม่ | PIGBET
        </title>
        <meta
          name="title"
          content="เว็บพนันออนไลน์ที่ดีที่สุด โปรโมชั่นแจกเครดิตฟรี สมาชิกใหม่ | PIGBET"
        />
        <meta
          property="og:title"
          content="เว็บพนันออนไลน์ที่ดีที่สุด โปรโมชั่นแจกเครดิตฟรี สมาชิกใหม่ | PIGBET"
        />
        <meta
          name="twitter:title"
          content="เว็บพนันออนไลน์ที่ดีที่สุด โปรโมชั่นแจกเครดิตฟรี สมาชิกใหม่ | PIGBET"
        />

        <meta
          name="description"
          content="เว็บพนันออนไลน์ที่ดีที่สุด โปรโมชั่นแจกเครดิตฟรี สมาชิกใหม่ รวมทุกเกมจากค่ายดัง  EVOLUTION ทางเข้าเว็บตรง พร้อมให้คุณทดลองเล่นได้แล้วที่นี่"
        />
        <meta
          property="og:description"
          content="เว็บพนันออนไลน์ที่ดีที่สุด โปรโมชั่นแจกเครดิตฟรี สมาชิกใหม่ รวมทุกเกมจากค่ายดัง  EVOLUTION ทางเข้าเว็บตรง พร้อมให้คุณทดลองเล่นได้แล้วที่นี่"
        />
        <meta
          name="twitter:description"
          content="เว็บพนันออนไลน์ที่ดีที่สุด โปรโมชั่นแจกเครดิตฟรี สมาชิกใหม่ รวมทุกเกมจากค่ายดัง  EVOLUTION ทางเข้าเว็บตรง พร้อมให้คุณทดลองเล่นได้แล้วที่นี่"
        />
      </Head>

      <div className={styles.header}>
        <Image
          src={promotionHeaderImage}
          alt="promotion pigbet"
          className={styles.img}
          fill
        />
      </div>
      <Section
        title={{ h1: 'PIGBET เว็บพนัน ครบวงจร ฝาก-ถอน ไม่มีขั้นต่ำ' }}
        sectionId={'seo-promotion-2'}
      >
        <span>
          เปิดตัวใหม่ล่าสุด กับ เว็บพนันPIGBET คาสิโนสดออนไลน์ครบวงจร
          ที่มาพร้อมกับ{' '}
          <Link href={pageLinkCommon.promotions}>
            โปรโมชั่น เว็บพนัน PIGBET
          </Link>{' '}
          สุดคุ้ม แจกจริงจ่ายหหนัก พร้อมช่องทางการฝาก-ถอน ไม่มีขั้นต่ำ
          ช่วยทำให้การเดิมพันนั้นกลายเป็นเรื่องง่าย การันตีด้วยการเป็น
          เว็บพนันออนไลน์ที่ดีที่สุด ที่เหล่าเซียนพนันตัวจริงต้องยกนิ้วให้
          พร้อมเปิดให้เดิมพันแล้ววันนี้ จบปัญหาเดิม ๆ ที่ไม่รู้ว่าจะเล่น
          พนันออนไลน์เว็บไหนดี ไปได้เลย!
        </span>
      </Section>
      <Section className={styles.container} sectionId={'seo-promotion-3'}>
        {allPromotions.map((promotion) => (
          <div
            key={promotion.code}
            className={styles.box}
            onClick={() =>
              handleClick(promotion.type === 'campaign', promotion.code)
            }
            onKeyDown={() =>
              handleClick(promotion.type === 'campaign', promotion.code)
            }
          >
            {!errorImage.includes(promotion.code) ? (
              <Image
                src={promotionImageAssetUrl(
                  promotion.type === 'campaign' ? 'campaigns' : 'promotions',
                  promotion.code,
                  `banner-${isMD ? 'md-lg-xl.webp' : 'xs-sm.webp'}`,
                )}
                alt={promotion.name}
                className={styles.img}
                width={isMD ? 1050 : 492}
                height={isMD ? 235 : 321}
                onError={() =>
                  setErrorImage((prev) => [...prev, promotion.code])
                }
              />
            ) : (
              <div
                className={styles.img}
                style={{
                  width: '100%',
                  height: 321,
                  backgroundColor: 'lightgrey',
                  display: 'grid',
                  justifyContent: 'center',
                  alignItems: 'flex-end',
                  paddingBottom: 16,
                }}
              >
                {promotion.name}
              </div>
            )}
            <div className={styles.details}>
              <span>รายละเอียด</span>
              <RightOutlined className={styles.icon} />
            </div>
          </div>
        ))}
      </Section>
      <Section
        title={{
          h2: 'รวมโปรเด็ด เว็บพนัน ฝาก-ถอน ไม่มีขั้นต่ำ ใหม่ ล่าสุด !',
        }}
        sectionId={'seo-promotion-4'}
      >
        <span>
          สำหรับ เว็บพนัน PIGBET นั้น
          นับว่าเป็นตัวจริงของคาสิโนสดออนไลน์ไม่ผ่านเอเย่นต์ 100%
          ที่พร้อมจะมาเปิดประสบการณ์สุดพิเศษให้กับเหล่าเซียนพนันตัวจริงเสียงจริง
          โดยเฉพาะบริการฝาก-ถอน ไม่มีขั้นต่ำ ไม่ต้องแชร์
          ไม่ต้องฝากก่อนก็รับทันทีเครดิตฟรีแรกเข้า 100 บาท พร้อมโปรเด็ดอื่น ๆ
          อีกมากมาย ที่จะช่วยทำให้การเล่นเกมพนันไม่มีข้อจำกัดเดิม ๆ อีกต่อไป
        </span>
        <br />
        <br />
        <span>
          นอกจากนี้ ที่ทางเข้าเว็บตรง เว็บพนัน คาสิโนสดออนไลน์ PIGBET
          ยังมีเกมให้เลือกมากมาย
          การันตีการเป็นเว็บคาสิโนที่ครบวงจรที่สุดเท่าที่เคยมีมา ไม่ว่าจะเป็น
          การปั่นบาคาร่าออนไลน์ ที่ครบครันทุกค่ายยอดฮิต การเล่นเกมรูเล็ตสุดปัง
          หนึ่งในการเดิมพันที่เล่นแล้วฟิน การลงพนันเกมเสือมังกร ไฮโล
          และไพ่แบล็คแจ็ค และปิดท้ายด้วยเกมโชว์
          ที่พร้อมจะมอบความสนุกสุดมันส์ให้แบบไม่จำกัด จากทางเข้า
          เว็บพนันออนไลน์ที่ดีที่สุด ตัวจริง!
        </span>
      </Section>
      <Section
        title={{ h2: 'เว็บพนัน ค่ายตรง เล่นเกมง่าย พร้อมโบนัสและเครดิตฟรี!' }}
        sectionId={'seo-promotion-5'}
      >
        <span>
          สำหรับคอพนันที่เข้ามาใช้บริการกับ เว็บพนัน PIGBET คาสิโนสดครบวงจร
          ไม่ผ่านเอเย่นต์แท้ 100%
          จะได้รับบริการสุดพรีเมียมจากโบนัสและเครดิตฟรีที่สูงสุด
          เพียงแค่ทำการสมัครสมาชิกเท่านั้น ซึ่งในส่วนของการรับเครดิตและโบนัสจาก
          เว็บพนันออนไลน์ที่ดีที่สุด นั้น
          สามารถใช้เดิมพันได้กับทุกเกมในหน้าหลักที่ทางเข้าเล่น พนันเว็บตรง
          ที่มีตัวเลือกให้อย่างมากมาย เล่นเกมแล้วฟิน
          แถมเครดิตฟรีแจกจริงไม่มีขั้นต่ำ แถมไม่ติดเทิร์นอีกด้วย
        </span>
      </Section>
      <Section
        title={{
          h2: 'รวมโปรเด็ดที่ห้ามพลาด เว็บพนัน PIGBET ตัวเลือกยืนหนึ่ง!',
        }}
        sectionId={'seo-promotion-6'}
      >
        <span>
          ขอบอกเลยว่า เว็บพนัน PIGBET ของเรา ไม่ได้มีดีแค่การขึ้นเป็นตัวเลือก
          เว็บพนันออนไลน์ที่ดีที่สุด ปี เท่านั้น
          แต่เรายังมีโปรโมชั่นดีดีจากเว็บตรงฝาก-ถอน ไม่มีขั้นต่ำด้วย
        </span>
      </Section>
      <Section
        title={{ h3: 'สมัครรับเครดิตฟรี เว็บพนันแจกจริงไม่มีล็อกยูส' }}
        sectionId={'seo-promotion-7'}
      >
        <span>
          สมาชิกใหม่ที่สมัคร เว็บพนัน วันนี้
          รับทันทีเครดิตฟรีจากการลงทะเบียนเป็นครั้งแรก ด้วยเครดิตฟรีสูงสุด 100
          บาท ใช้เล่นเกมได้ทุกค่ายและการเดิมพันในเว็บตรง และในทุก ๆ ยอดฝาก
          ก็รับโบนัสเพิ่มอีกทันที 10%
          ไม่มีการจำกัดวงเงินในการเติมเงินเข้าสู่ระบบแน่นอน
        </span>
      </Section>
      <Section sectionId={''}>
        <center>
          <Link href={pageLinkCommon.login}>
            สมัคร PIGBET คาสิโน บาคาร่า ออนไลน์
          </Link>
        </center>
      </Section>
      <Section
        title={{ h3: 'การันตีคืนยอดเสีย 5% สูงสุดในวงการ' }}
        sectionId={'seo-promotion-8'}
      >
        <span>
          หากเดิมพันแล้วเสียก็ไม่ต้องกังวล เพราะนอกจากจะรับเครดิตฟรีจาก เว็บพนัน
          เรายังมีการคืนยอดเสียให้กับนักเดิมพันทุกคนสูงสุดถึง 5%
          มากกว่าเว็บคาสิโนอื่น ๆ ที่ให้พียง 0.5 – 1% เท่านั้น
          เป็นอีกหนึ่งตัวเลือกที่ติด Top มาแรงของ พนันออนไลน์เว็บไหนดี
          ที่เหล่าเซียนแนะนำ
        </span>
      </Section>
      <Section
        title={{
          h3: 'ยิ่งชวนยิ่งได้ รับเครดิตฟรี x3 แค่ชวนเพื่อนสมัคร เว็บพนัน',
        }}
        sectionId={'seo-promotion-9'}
      >
        <span>
          อีกหนึ่งโปรดีที่ห้ามพลาด ก็ต้องยกให้กับชวนเพื่อนสมัคร เว็บพนัน ออนไลน์
          PIGBET วันนี้ รับทันที เครดิตฟรีสูงสุดถึง 3 ต่อ ฟินจุใจแน่นอน
        </span>
        <ul>
          <li>
            รับค่าคอมทันทีที่เพื่อนสมัคร เว็บพนัน ถึง 50 บาท ต่อ 1 User
            ยิ่งชวนยิ่งได้!
          </li>
          <li>
            ต่อที่ 2 รับทันทีค่าคอม 50% จากยอดฝากของเพื่อนที่ชวนเข้ามาเดิมพัน
          </li>
          <li>
            และคุ้มอีก 1 ต่อ รับเพิ่มอีก 10% จากยอดเสียของเพื่อน ให้จริงจาก
            เว็บพนัน ไม่ผ่านเอเย่นต์
          </li>
        </ul>
      </Section>
      <Section
        title={{ h3: 'เว็บพนัน ถอน ไม่มีขั้นต่ำ ไม่ติดเทิร์น ไม่ล็อกยูส' }}
        sectionId={'seo-promotion-10'}
      >
        <span>
          และอีกหนึ่งโปรพิเศษที่ห้ามพลาด คือบริการ เว็บพนัน ถอน ไม่มีขั้นต่ำ
          ที่ไม่มีการล็อกยูสหรือติดเทิร์นแน่นอน สามารถถอนเงินออกได้ตลอด 24 ชม.
          ผ่านระบบการทำธุรกรรมที่ปลอดภัย รองรับทุกระบบปฏิบัติการ จะฝาก-ถอน
          เว็บพนัน ผ่าน Wallet ก็ง่าย จบปัญหาเดิม ๆ เล่นพนันแล้วถอนเงินไม่ได้!
        </span>
      </Section>
      <Section
        title={{
          h2: 'รับโบนัสทุกยอดฝาก เติมเงินกับ เว็บพนัน รับอีก 10% ทันที',
        }}
        sectionId={'seo-promotion-11'}
      >
        <span>
          อีกหนึ่งความปังจาก เว็บพนัน PIGBET
          ก็คือการให้โบนัสเพิ่มเติมสำหรับคอพนัน ที่เข้ามาเดิมพันกับทาง
          เว็บพนันออนไลน์ที่ดีที่สุด วันนี้ ด้วยโบนัสจากยอดฝากที่ให้อีกถึง 10%
          ไม่มีการจำกัดวงเงินในการฝาก
          ซึ่งเคริตฟรีจากการฝากเงินจะถูกเติมเข้าสู่เครดิตไปยัง “กระเป๋าโบนัส”
          และ “กระเป๋าเงินสด” แบบอัตโนมัติ เรียกว่าเป็นการ ฝาก-ถอน ออโต้
          ก็ได้เช่นกัน{' '}
        </span>
        <br />
        <br />
        <span>
          นอกจากนี้ ในการรับโบนัสจากยอดฝาก เครดิตฟรีที่ได้รับจาก เว็บพนัน
          ไม่ผ่านเอเย่นต์ จะมีอายุทั้งหมด 30 วัน นับจากวันที่ฝากเงินเข้าสู่ระบบ
          เพราะฉะนั้น สามารถใช้ในการเดิมพันได้แบบยาว ๆ
          อยากจะเล่นเกมไหนในคาสิโนก็รองรับ ทั้งในส่วนของการเดิมพันกับทาง PIGSPIN{' '}
          {PIGSPIN_URL && <Link href={PIGSPIN_URL}>เว็บตรง สล็อต pg slot</Link>}
          และ PIGBET เพราะฉะนั้น ตอบโจทย์นักเดิมพันที่กำลังไม่รู้ว่าจะแทงพนันกับ
          พนันออนไลน์เว็บไหนดี ที่ให้ผลตอบแทนสูง
        </span>
      </Section>
      <Section
        title={{
          h2: 'เว็บตรงเล่นเกมง่าย คาสิโนสดออนไลน์ โบนัสสูงสุดพร้อมบริการทดลองเล่น',
        }}
        sectionId={'seo-promotion-12'}
      >
        <span>
          อย่างไรก็ตาม ในการเข้ามาร่วมสนุกกับ เว็บพนัน PIGBET ขอการันตีเลยว่า
          ทุกท่านจะได้รับโบนัสจากการเล่นเกมทุกเกมที่สูงสุดแน่นอน
          โดยเฉพาะการถ่ายทอดสดแบบ Real Time จากโต๊ะพนันของจริงที่มีความคมชัดสูง
          เล่นเกมแล้วเสถียรมากกว่า แถมยังสามารถฝากเงินกับ เว็บพนัน ถอน
          ไม่มีขั้นต่ำ แล้วเล่นเกมได้ทันที
        </span>
        <br />
        <br />
        <span>
          นอกจากนี้ เรายังมีบริการทดลองเล่นเกมคาสิโนสด
          ที่สามารถเข้ามาร่วมสนุกกับเกมใหม่ ๆ ที่เปิดให้บริการได้ก่อนใคร
          เพียงแค่ยืนยันตัวตนผ่าน OTP ไม่ต้องฝาก ไม่ต้องแชร์ กับทางเข้า เว็บพนัน
          PIGBET เท่านั้น ก็สามารถเข้ามาเล่นเกมได้ทันที
          หรือหากเติมเงินวันนี้ก็จะได้รับโบนัสทุกยอดฝาก 10%
          บอกเลยว่าเราคือตัวจริงของ เว็บพนันออนไลน์ที่ดีที่สุด ที่คุณต้องไม่พลาด
        </span>
      </Section>
    </>
  )
}

export const getStaticProps = withMiddleware(async ({ queryClient }) => {
  await queryClient.prefetchQuery([promotionsApi.key.list], () =>
    promotionsApi.list({ productType: 'PIG_BET' }),
  )
  await queryClient.prefetchQuery([campaignApi.key.list], () =>
    campaignApi.list({ types: 'leaderboard', productType: 'PIG_BET' }),
  )

  return { revalidate, props: {} }
})
